var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-of-contents" },
    [
      _vm._l(_vm.forms, function (form) {
        return _c(
          "div",
          {
            key: form.id,
            class: _vm.classesForItem(form),
            on: {
              click: function ($event) {
                return _vm.setOfferFormId(form.id)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(form.name) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _vm._m(0),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "table-of-contents__item",
        attrs: {
          href: "https://1cbo.ru/rates_and_services/offer2/",
          target: "_blank",
        },
      },
      [
        _vm._v("\n    Правила обслуживания\n    "),
        _c("img", {
          attrs: {
            src: require("@icons/external-link.svg"),
            alt: "external-link.svg",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }